import { Component, OnDestroy, OnInit, HostBinding } from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { AuthenticationService } from './shared/services';
import { UserService } from './shared/services/user.service';
import { SynchronizationEventService } from './modules/synchronization/services/synchronization-event.service';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();

    constructor(
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private synchronizationEventService: SynchronizationEventService
    ) {}

    @HostBinding('class')
    hostClass = 'app';

    ngOnInit() {
        this.userService
            .getUser()
            .pipe(take(1))
            .subscribe(user => {
                this.authenticationService.setIsAuthenticated(user);
            });

        this.synchronizationEventService.changes.pipe(takeUntil(this.destroy$)).subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
